import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
    root: {
        fontWeight: 400,
        minHeight: 48,
        borderBottom: "1px solid #D0D0D0",
        flexDirection: "row",
    },
    articleColumnContainer: {
        flex: 5,
        justifyContent: "center",
        paddingLeft: 5,
    },
    articleText: {
        fontWeight: 600,
        fontSize: 8,
    },
    articleNrColumnContainer: {
        flex: 3,
        justifyContent: "center",
    },
    articleNrText: {
        fontSize: 8,
    },
    modelColumnContainer: {
        flex: 6,
        justifyContent: "center",
    },
    modelText: {
        fontSize: 8,
    },
    availabilityColumnContainer: {
        flex: 4,
        alignItems: "center",
        flexDirection: "row",
    },
    availabilityIcon: {
        width: 4,
        height: 4,
        borderRadius: 2,
        marginRight: 3,
    },
    availabilityText: {
        fontSize: 8,
    },
    priceColumnContainer: {
        flex: 2,
        justifyContent: "center",
    },
    priceText: {
        fontWeight: 600,
        fontSize: 8,
    },
    quantityColumnContainer: {
        flex: 1,
        justifyContent: "center",
    },
    quantityText: {
        fontSize: 8,
    },
    separator: {
        height: 1,
        width: "100%",
        backgroundColor: "#D0D0D0",
    },
});
